import React from 'react';
import { connect } from 'react-redux';
import HoverDropdown from './HoverDropdown';


const AiInsightsHeader = ({ aiInsightsCategories, selectedCategory, selectedSubCategoryId, selectedCategoryInBeta }) => (
  <div className="ai-insights-header">
    {selectedCategoryInBeta && <span className="ai-insights-header-beta-tag">BETA</span>}
    {aiInsightsCategories?.map((catObj) => {
      const categoryName = Object.keys(catObj)[0];
      const subCategories = catObj[categoryName];

      return (
        <HoverDropdown
          key={categoryName}
          title={categoryName}
          items={subCategories}
          activeKey={selectedSubCategoryId}
          isActive={selectedCategory === categoryName}
        />

      );
    })}
  </div>
);


const mapStateToProps = ({ AiInsightsReducer }) => {
  const { aiInsightsCategories, aiInsightsSettings, selectedCategoryInBeta } = AiInsightsReducer;
  const { selectedCategory, selectedSubCategoryId } = aiInsightsSettings;

  return { aiInsightsCategories, selectedCategory, selectedSubCategoryId, selectedCategoryInBeta };
};


export default connect(mapStateToProps)(AiInsightsHeader);
